function widows() {
  var nbspSelectors = [
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote'
  ];
    
    var nbspWordMin = 6;
    
    nbspSelectors.forEach(function(selector) {
        var nbspElements = document.querySelectorAll(selector);
        nbspElements.forEach(function(element) {
            var wordCount = (element.innerHTML.split(" ").length);
            if (wordCount >= nbspWordMin ) {
                element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/,'&nbsp;$1');
            }
        });
    });
  }
  export default {
    init: function () {
      widows();
    }
  };
  